import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { primengImports } from '../../primengImports';
import { MainService } from '@services/utilities/main.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-confirm-dialog',
  imports: [CommonModule, primengImports],
  templateUrl: './confirm-dialog.html',
  styleUrl: './confirm-dialog.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class ConfirmDialog implements OnInit, OnDestroy {
  private mainService = inject(MainService);
  private subscription: Subscription = new Subscription();

  @Input() visible: boolean = false;
  @Input() title: string = 'Confirmar';
  @Input() message: string = '¿Estás seguro de que deseas continuar?';
  @Input() icon: string = 'pi-exclamation-triangle'; // Ícono de advertencia
  @Input() iconSize: string = '3rem';
  @Input() iconColor: string = '#f39c12'; /// Color del ícono | Acepta hex o clases Tailwind
  @Input() confirmLabel: string = 'Eliminar';
  @Input() cancelLabel: string = 'Cancelar';
  @Input() confirmButtonClass: string = 'btn-primary'; // Para acciones eliminar usar 'text-rojo-300'
  @Input() cancelButtonClass: string = 'btn-text'; // O 'btn-secondary'

  // Los @Output se mantienen por si se usa el componente de forma local, pero no son necesarios para el control global.
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  // Callbacks para las acciones globales
  private onConfirmCallback: () => void = () => {};
  private onCloseCallback: () => void = () => {};

  ngOnInit() {
    if (!this.onConfirm.observed) {
      this.subscription.add(
        this.mainService.confirmAction$.subscribe(action => {
          this.message = action.message;
          this.confirmLabel = action.confirmLabel || 'Confirmar';
          this.onConfirmCallback = action.onConfirm;
          this.onCloseCallback = action.onClose;
          this.visible = true;
        })
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


  isTailwindColor(color: string): boolean {
    return !color.startsWith('#') && !color.startsWith('rgb') && !color.startsWith('hsl');
  }

  onConfirmAction() {
    this.onConfirmCallback(); 
    this.onConfirm.emit();   
    this.closeDialog();
  }

  onCancelAction() {
    this.onCloseCallback();   
    this.onCancel.emit();     
    this.closeDialog();
  }

  private closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible); 
  }
}
